import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const getSearchQuery = (params) => (
  `${params ? `?${new URLSearchParams(params).toString()}` : ''}`
);

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
  endpoints: (builder) => ({
    events: builder.query({
      query: (params) => ({
        url: `/get-events${getSearchQuery(params)}`,
      }),
    }),
  }),
});

export const {
  useEventsQuery,
} = apiSlice;
